"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_LOOKBACK_DURATION = void 0;
exports.filterRecentMeasurements = filterRecentMeasurements;
exports.transformAndFilterReconMeasurements = void 0;
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
var _moment = _interopRequireDefault(require("moment"));
var _measurements = require("../../../query/measurements");
const MIN_LOOKBACK_DURATION = exports.MIN_LOOKBACK_DURATION = 30 * 24 * 3600; // 30 days in seconds

/**
 * Virtual NMS dimensions that are cross-compatible with all NMS measurements.
 * These aren't returned by the API schema but are accepted as filter fields by the NMS backend.
 * Mirrors the extra options appended in MetricsExplorerSidebar.availableDimensionFilterOptions.
 */
const NMS_VIRTUAL_DIMENSIONS = {
  i_device_label: {
    Label: 'Device Label',
    Type: 'string',
    FilterOnly: true
  },
  i_output_interface_group: {
    Label: 'Interface Group',
    Type: 'string'
  }
};

/** Merge virtual NMS dimensions into a measurement's Dimensions, only for keys not already present. */
function injectVirtualDimensions(m) {
  const existing = m.storage?.Dimensions ?? {};
  const toInject = {};
  for (const [key, dim] of Object.entries(NMS_VIRTUAL_DIMENSIONS)) {
    if (!(key in existing)) {
      toInject[key] = dim;
    }
  }
  if (Object.keys(toInject).length === 0) {
    return m;
  }
  return {
    ...m,
    storage: {
      ...m.storage,
      Dimensions: {
        ...toInject,
        ...existing
      }
    }
  };
}
function prefixMeasurementPaths(rawMeasurements) {
  return rawMeasurements.map(m => injectVirtualDimensions({
    ...m,
    measurement: m.measurement.startsWith('/metrics') ? m.measurement : `/metrics${m.measurement.startsWith('/') ? '' : '/'}${m.measurement}`
  }));
}
function filterRecentMeasurements(measurements, lookback) {
  const sanitizedDuration = Math.max(lookback, MIN_LOOKBACK_DURATION);
  const deadline = (0, _moment.default)().subtract(sanitizedDuration, 'seconds');
  return measurements.map(measurement => {
    if (!measurement.last_seen) {
      return measurement;
    }
    if (deadline.isAfter((0, _moment.default)(measurement.last_seen))) {
      return null;
    }
    return {
      ...measurement,
      storage: {
        ...measurement.storage,
        Metrics: (0, _pickBy2.default)(measurement.storage.Metrics, metric => (0, _measurements.isQueryableMetric)(metric) && deadline.isBefore((0, _moment.default)(metric.LastSeen))),
        Dimensions: (0, _pickBy2.default)(measurement.storage.Dimensions, dimension => deadline.isBefore((0, _moment.default)(dimension.LastSeen)))
      }
    };
  }).filter(m => m !== null).filter(m => Object.keys(m.storage.Metrics).length > 0);
}
const transformAndFilterReconMeasurements = (measurements, options) => {
  // If no lookback is provided, return all measurements with prefixed paths
  if (options?.lookback === undefined) {
    const filtered = measurements.map(m => ({
      ...m,
      storage: {
        ...m.storage,
        Metrics: (0, _pickBy2.default)(m.storage.Metrics, _measurements.isQueryableMetric)
      }
    }));
    return prefixMeasurementPaths(filtered);
  }
  const recentMeasurements = filterRecentMeasurements(measurements, options.lookback);
  return prefixMeasurementPaths(recentMeasurements);
};
exports.transformAndFilterReconMeasurements = transformAndFilterReconMeasurements;